    <div *ngIf="notification && showNotification" (click)="clearNotice()" class="notification">
      <p>{{ notification }}</p>
    </div>
